import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {fromEvent, Observable, pipe} from 'rxjs';
import {filter, repeatWhen, switchMapTo, take, tap} from 'rxjs/operators';

export type KeyboardShortcut = (keyboardEvent: KeyboardEvent) => boolean;

@Injectable()
export class KeyboardShortcutService {

    private static getKeyCodeFromEvent(event: KeyboardEvent): number {
        return event.which || event.keyCode || 0;
    }

    constructor(
        @Inject(DOCUMENT)
        private document: Document
    ) {}

    public createHotKey(keyCode: number): KeyboardShortcut {
        return keyboardEvent => KeyboardShortcutService.getKeyCodeFromEvent(keyboardEvent) === keyCode;
    }

    public onHold(shortcut: KeyboardShortcut): Observable<boolean> {
        return new Observable<boolean>(subscriber => {
            const keyFilter = pipe(
                filter<KeyboardEvent>(shortcut),
                take(1)
            );
            const emit = (state: boolean) => tap(() => subscriber.next(state));
            const keyDown$ = fromEvent<KeyboardEvent>(this.document, 'keydown').pipe(
                keyFilter,
                emit(true)
            );
            const keyUp$ = fromEvent<KeyboardEvent>(this.document, 'keyup').pipe(
                keyFilter,
                emit(false)
            );
            const switchToKeyUp = repeatWhen(completed$ => completed$.pipe(
                switchMapTo(keyUp$)
            ));

            return keyDown$.pipe(switchToKeyUp).subscribe();
        });
    }

}
